module.exports = __webpack_public_path__ + "img/home-a.f4ff9a70.svg";